import React, { useState, useEffect } from 'react'
import {  Button } from 'react-bootstrap';
import Pagination from 'react-bootstrap-4-pagination';
import BaoCaoChatLuongDatApi from '../../api/BaoCaoChatLuongDatApi';

export const SoLieu = (props) => {
    const loaiBaoCao=2;
    const [listBaoCaos, setBaoCao] = useState([]);
    const [filter, setFilter] = useState('');
    let pageIndex = 1;
    let pageSize = 20;
    const [paginationConfig, setPaging] = useState({
        totalPages: 1,
        currentPage: 1,
        showMax: 5,
        size: "sm",
        threeDots: true,
        prevNext: true,
        center: true,
        onClick: function (page) {
            pageIndex = page;
            loadBaoCao();
        }
    });

    const loadBaoCao = async () => {
        try {
            const params = {
                pageIndex: pageIndex,
                pageSize: pageSize,
                keyword: props.keyword,
                idQuanHuyen: props.huyen.value,
                loaiBaoCao:loaiBaoCao
            }
            const response = await BaoCaoChatLuongDatApi.getPagingPublic(params);
            response.Items.forEach(item => {
                item.Checked = false;
            });
            paginationConfig.totalPages = response.TotalRow == 0 ? 1 : Math.ceil(response.TotalRow / pageSize);
            paginationConfig.currentPage = pageIndex;
            setPaging(paginationConfig);
            setBaoCao(response.Items);
        } catch (err) {
        }
    }

    useEffect(()=>{
        if(props.huyen.value !== 0){
            loadBaoCao();
        }
    }, [props.huyen.value]);

    useEffect(() => {
        loadBaoCao();
    }, [props.keyword]);

    return (
        <div className="card shadow mb-1">
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-bordered" width="100%">
                        <thead>
                            <tr>
                                <th>Tên</th>
                                <th>Xã</th>
                                <th>Mô tả</th>
                                <th>Tập tin</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listBaoCaos.map((item, key) => {
                                    return (
                                        <tr key={key}>
                                            <td>{item.Ten}</td>
                                            <td>{item.TenQuanHuyen}</td>
                                            <td>{item.MoTa}</td>
                                            <td className="col-taptin">{item.TapTin != null?(
                                                <a href={process.env.REACT_APP_URL + item.TapTin} target="_bank"><i className="fa fa-file"></i></a>
                                            ):''}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className="col-md-12 phan-trang">
                    <Pagination {...paginationConfig} />
                </div>
            </div>
        </div>
    )
}
